export enum ConsiderationStatusChoices {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  CANCELED = "CANCELED",
}

export enum ConsiderationTypeChoices {
  PT_CONSULT_CONSIDERATION = "PT_CONSULT_CONSIDERATION",
  HOSPITAL_AT_HOME_CONSIDERATION = "HOSPITAL_AT_HOME_CONSIDERATION",
}

interface Consideration {
  type: string;
  display_text: string;
}

interface PatientConsideration {
  id: number;
  patient_id: number;
  consideration: Consideration;
  consideration_reasoning_title: string;
  consideration_reasoning_description: string;
  status: ConsiderationStatusChoices;
  source: string;
  metadata: Record<string, any>;
  updated_by?: string;
  updated_by_name?: string;
  qv_updated_ts?: string;
}

export default PatientConsideration;
